import { render, staticRenderFns } from "./LandingPageTemplate.vue?vue&type=template&id=3e0e78b8&scoped=true"
import script from "./LandingPageTemplate.vue?vue&type=script&lang=js"
export * from "./LandingPageTemplate.vue?vue&type=script&lang=js"
import style0 from "./LandingPageTemplate.vue?vue&type=style&index=0&id=3e0e78b8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0e78b8",
  null
  
)

export default component.exports